import { useEffect, useState } from 'react';

import { network } from '../services';

export const useNetwork = () => {
  const [isOnline, setIsOnline] = useState<boolean>(true);

  useEffect(() => {
    const handleNetworkChange = (_isOnline: boolean) => {
      setIsOnline(_isOnline);
    };

    network.addCallback(handleNetworkChange);

    return () => {
      network.removeListeners();
    };
  }, []);

  return { isOnline };
};
